import * as yup from 'yup'

const schema = yup.object().shape({
  dataProcessId: yup.string(),
  reasonExclusion: yup.string().required(),
})

export default schema
